<template>
  <div class="container">
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="left">
          <slot name="leftTop"></slot>
          <div class="leftContent">
            <slot name="content"></slot>
            <pagination
              v-show="total>0"
              :total="total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              @pagination="(e) => getList(e)"
              v-if="isShowPagination"
            />
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="right">
          <div class="rightTop">
            <img src="../../assets/img/event/problem.png" />
            <div>{{detailTitle}}</div>
          </div>
          <slot name="detail"></slot>
          <slot name="bottom"></slot>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination";

export default {
  components: {
    Pagination,
  },
  props: {
    detailTitle: {
      type: String,
      default: "详情",
    },
    total: {
      type: Number,
      default: 0,
    },
    isShowPagination: {
      type: Boolean,
      default: true,
    },
    listQuery: {
      type: Object,
      default: () => ({
        page: 1,
        limit: 10,
      }),
    },
    getList: {
      type: Function,
      default: function () {
        return [];
      },
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  padding: 24px 26px;
  box-sizing: border-box;
  width: 100%;
}

.middle {
  background: #f5f6fd;
}
.leftTop {
  line-height: 69px;
}
.left,
.right {
  height: 850px;
  border-radius: 6px;
  background: #fff;
}

.right {
  padding: 16px;
  box-sizing: border-box;
  overflow: scroll;
}

.leftContent {
  padding: 30px 26px;
  box-sizing: border-box;
}

.pagination-container {
  padding: 20px 16px 10px 16px;
}

.rightTop {
  display: flex;
  box-sizing: border-box;
  img {
    width: 18px;
    height: 20px;
    margin-right: 9px;
    vertical-align: middle;
  }
  padding-bottom: 22px;
  border-bottom: 1px solid #e2e5ec;
}
</style>